import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { RequireAuth } from "./components/RequireAuth";
import { currentVertical } from "./lib/vertical";
import { SignIn } from "./pages/SignIn";

// Flights
import { Search } from "./pages/Search";
import { Results } from "./pages/Results";
import { Passengers } from "./pages/Passengers";
// Reprice was a standalone page — folded into Payment now. The route below
// just redirects so any stale URL still lands the user in the right place.
import { Payment } from "./pages/Payment";
import { Confirmation } from "./pages/Confirmation";
import { MyBookings } from "./pages/MyBookings";
import { BookingDetail } from "./pages/BookingDetail";

// Hotels
import { HotelSearch } from "./pages/HotelSearch";
import { HotelResults } from "./pages/HotelResults";
import { HotelDetail } from "./pages/HotelDetail";
import { HotelGuests } from "./pages/HotelGuests";
import { HotelPayment } from "./pages/HotelPayment";
import { HotelConfirmation } from "./pages/HotelConfirmation";
import { HotelBookings } from "./pages/HotelBookings";
import { HotelBookingDetail } from "./pages/HotelBookingDetail";

// Reprice page no longer exists — bounce to Pay.
function RepriceRedirect() {
  const id = window.location.pathname.match(/booking\/([^/]+)\/reprice/)?.[1];
  return <Navigate to={`/booking/${id}/payment`} replace />;
}

function ProtectedShell() {
  return (
    <RequireAuth>
      <Nav />
      <Outlet />
      <Footer />
    </RequireAuth>
  );
}

// Two route trees behind one router. Which one mounts is decided by the URL
// prefix Django served the app under (see lib/vertical.ts), so the paths inside
// each tree are identical and relative — `/results` is /flights/results here and
// /hotels/results there.
function FlightRoutes() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route element={<ProtectedShell />}>
        <Route index element={<Search />} />
        <Route path="results" element={<Results />} />
        <Route path="booking/:bookingId/passengers" element={<Passengers />} />
        <Route path="booking/:bookingId/reprice" element={<RepriceRedirect />} />
        <Route path="booking/:bookingId/payment" element={<Payment />} />
        <Route path="booking/:bookingId/confirmation" element={<Confirmation />} />
        <Route path="bookings" element={<MyBookings />} />
        <Route path="bookings/:bookingId" element={<BookingDetail />} />
      </Route>
      <Route path="*" element={<div className="app-error">Page not found.</div>} />
    </Routes>
  );
}

function HotelRoutes() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route element={<ProtectedShell />}>
        <Route index element={<HotelSearch />} />
        <Route path="results" element={<HotelResults />} />
        {/* The room picker lives on the hotel page — details and room
            selection are one step, because a room only means anything next to
            the property it's in. */}
        <Route path="hotel/:hotelId" element={<HotelDetail />} />
        <Route path="booking/:bookingId/guests" element={<HotelGuests />} />
        <Route path="booking/:bookingId/payment" element={<HotelPayment />} />
        <Route path="booking/:bookingId/confirmation" element={<HotelConfirmation />} />
        <Route path="bookings" element={<HotelBookings />} />
        <Route path="bookings/:bookingId" element={<HotelBookingDetail />} />
      </Route>
      <Route path="*" element={<div className="app-error">Page not found.</div>} />
    </Routes>
  );
}

export function App() {
  return currentVertical() === "hotels" ? <HotelRoutes /> : <FlightRoutes />;
}
